import React from 'react';

import {withStyles} from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from "@material-ui/core/AppBar/AppBar";
import Toolbar from "@material-ui/core/Toolbar/Toolbar";
import {ApolloProvider} from "react-apollo";

import {
    // ToolbarSearch,
    ToolbarSpacer,
    ToolbarLogo,
    ToolbarIcon,
    ToolbarProfile,
} from '../Toolbar';

import {
    Navigation,
    createPaths
} from '../Navigation';

import {
    Breadcrumb,
    BreadcrumbItem,
} from "../Breadcrumb";

import {
    Notification,
    getNotifications,
    countNotifications,
} from '../Notification';

const styles = theme => ({
    root: {
        display: 'flex',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing.unit * 3,
        height: '100vh',
        overflow: 'auto',
    },
    contentSpacer: theme.mixins.toolbar,
});

const Layout = ({classes, children}) => (
    <React.Fragment>
        <ApolloProvider client={window.apolloClient}>
            <CssBaseline/>
            <div className={classes.root}>
                {/* App Main Bar */}
                <AppBar
                    position="fixed"
                    color="secondary"
                    className={classes.appBar}
                >
                    <Toolbar>
                        <ToolbarLogo
                            href="/"
                            src="/images/iba-logo.png?v=3"
                        />
                        <ToolbarSpacer/>
                        {window.can('projects.view') && (
                            <React.Fragment>
                                <ToolbarIcon
                                    component="a"
                                    icon="speaker_notes"
                                    href="/notes/create"
                                />
                                <ToolbarIcon
                                    component="a"
                                    badge={countNotifications(window.__DATA__._user)}
                                    icon="notifications"
                                    href="/notifications"
                                />
                            </React.Fragment>
                        )}
                        <ToolbarProfile
                            user={window.__DATA__._user}
                        />
                    </Toolbar>
                </AppBar>

                {/* App Navigation Drawer */}
                <Navigation items={window.__DATA__._menu}/>

                {/* App Content */}
                <main className={classes.content}>
                    <div className={classes.contentSpacer}/>

                    {/* Notification partial */}
                    {/*
                    <Notification
                        notifications={getNotifications(window.__DATA__._user)}
                    />
                    */}

                    <Breadcrumb>
                        {window.__DATA__.breadcrumbs.map((item, idx) => (
                            <BreadcrumbItem
                                key={`breadcrumb_${idx}`}
                                label={item.title}
                                onClick={() => window.location = item.url}
                            />
                        ))}
                    </Breadcrumb>

                    {children}
                </main>
            </div>
        </ApolloProvider>
    </React.Fragment>
);

export default withStyles(styles)(Layout);
